import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApAlertService } from './ap-alert.service';
import { ApAlert, ApAlertType } from './ApAlert';

@Component({
  selector: 'ap-alert',
  templateUrl: 'ap-alert.component.html',
})
export class ApAlertComponent implements OnInit, OnDestroy {
  @Input() id = 'default-alert';
  @Input() fade = true;

  alerts: ApAlert[] = [];
  alertSubscription$: Subscription;

  constructor(private alertService: ApAlertService) { }

  ngOnInit() {

    this.alertSubscription$ = this.alertService.onAlert(this.id)
      .subscribe((alert) => {
        this.addNewAlert(alert);
      });
  }

  ngOnDestroy() {
    this.alertSubscription$.unsubscribe();
  }

  removeAlert(alert: ApAlert) {
    if (!this.alerts.includes(alert)) return;

    if (this.fade) {
      const alertToRemove = this.alerts.find((x) => x === alert);
      if (alertToRemove) {
        alertToRemove.fade = true;
      }

      setTimeout(() => {
        this.alerts = this.alerts.filter((x) => x !== alert);
      }, 250);
    } else {
      this.alerts = this.alerts.filter((x) => x !== alert);
    }
  }

  cssClass(alert: ApAlert) {
    if (!alert) return;

    const classes = [];

    const alertTypeClass = {
      [ApAlertType.Success]: 'alert alert-success alert-dismissable',
      [ApAlertType.Info]: 'alert alert-info alert-dismissable',
      [ApAlertType.Error]: 'alert alert-danger alert-dismissable',
      [ApAlertType.Warning]: 'alert alert-warning alert-dismissable',
    };

    classes.push(alertTypeClass[alert.type]);

    if (alert.fade) {
      classes.push('fade');
    }

    return classes.join(' ');
  }

  private addNewAlert(alert: ApAlert) {

    if (!alert.message) {
      this.alerts = [];
      return;
    }

    this.alerts.push(alert);

    if (alert.autoClose && alert.autoCloseTimeout) {
      setTimeout(() => this.removeAlert(alert), alert.autoCloseTimeout);
    }
  }
}
